export const encyclopediaPl = {
  // Shared
  'encyclopedia.lockAria': 'Zablokowane — odblokuj, aby przeczytać',

  // EncyclopediaPage
  'encyclopedia.page.seoTitle': 'Encyklopedia',
  'encyclopedia.page.seoDescription':
    'Przeszukaj żywy grimoire Grymwyrd — potwory, zaklęcia, rasy, przedmioty, lokacje i wiele więcej.',
  'encyclopedia.page.heading': 'Encyklopedia',
  'encyclopedia.page.subtitle': 'Żywy grimoire każdego horroru, zaklęcia i legendy Grymwyrd.',
  'encyclopedia.page.searchPlaceholder': 'Szukaj {plural}…',
  'encyclopedia.page.searchAria': 'Szukaj {plural}',
  'encyclopedia.page.clearSearch': 'Wyczyść wyszukiwanie',
  'encyclopedia.page.systemNotLivePrefix': 'Zasłona nie rozwarła się jeszcze dla',
  'encyclopedia.page.systemNotLiveSuffix':
    '. Żadne losy powiązane z tym rytuałem nie przeniknęły — jego grimoire czeka poza ciemnością.',
  'encyclopedia.page.returnToAllSystems': 'Wróć do wszystkich systemów',
  'encyclopedia.page.settingNotLivePrefix': 'Ziemie',
  'encyclopedia.page.settingNotLiveSuffix':
    ' są wciąż mapowane — ich wpisy nie są jeszcze powiązane z ustawieniem. Dopóki kartografowie nie skończą, tu nic się nie pojawia.',
  'encyclopedia.page.returnToAllRealms': 'Wróć do wszystkich światów',
  'encyclopedia.page.filteringBy': 'Filtrowanie po',
  'encyclopedia.page.filterSystem': 'systemem "{label}"',
  'encyclopedia.page.filterCanon': 'warstwie kanonu "{label}"',
  'encyclopedia.page.filterSetting': 'świecie "{label}"',
  'encyclopedia.page.canonNote': 'Warstwa kanonu stosuje się po oznaczeniu encji w API (patrz _docs/13). ',
  'encyclopedia.page.clear': 'Wyczyść',
  'encyclopedia.page.hide': 'Ukryj',
  'encyclopedia.page.filter': 'Filtr',

  // EntityCard
  'encyclopedia.entityCard.unlockAria': 'Odblokuj {name} (zawartość Grymwyrd)',
  'encyclopedia.entityCard.viewAria': 'Wyświetl wpis {name}',

  // EntityGrid
  'encyclopedia.grid.paginationAria': 'Paginacja ({position})',
  'encyclopedia.grid.prev': 'Wstecz',
  'encyclopedia.grid.next': 'Dalej',
  'encyclopedia.grid.pageOf': 'Strona {page} z {totalPages}',
  'encyclopedia.grid.resultsAria': '{plural} wyników',
  'encyclopedia.grid.scrying': 'Czytanie archiwów…',
  'encyclopedia.grid.count': '{total} {plural}',
  'encyclopedia.grid.sortDescAria': 'Sortuj malejąco',
  'encyclopedia.grid.sortAscAria': 'Sortuj rosnąco',
  'encyclopedia.grid.sortAZ': 'A–Z',
  'encyclopedia.grid.sortZA': 'Z–A',
  'encyclopedia.grid.viewModeAria': 'Tryb widoku',
  'encyclopedia.grid.gridViewAria': 'Widok siatki',
  'encyclopedia.grid.listViewAria': 'Widok listy',
  'encyclopedia.grid.jumpToLetterAria': 'Przejdź do litery',
  'encyclopedia.grid.all': 'Wszystko',
  'encyclopedia.grid.letterSymbolAria': 'Wpisy zaczynające się od cyfry lub symbolu',
  'encyclopedia.grid.letterAria': 'Wpisy zaczynające się od {letter}',
  'encyclopedia.grid.emptyTitle': 'Archiwum jest Milczące',
  'encyclopedia.grid.emptyForLetter': 'Żaden {plural} nie nosi imienia zaczynającego się od „{letter}".',
  'encyclopedia.grid.emptyAll': 'Żaden {plural} nie odpowiada twojemu wezwaniu.',
  'encyclopedia.grid.turningPages': 'Kartkowanie…',

  // EntityImage
  'encyclopedia.entityImage.noArtworkAria': '{label} (brak ilustracji)',
  'encyclopedia.entityImage.noVision': 'Bez Wizji',

  // FacetSidebar
  'encyclopedia.facets.all': 'Wszystko',
  'encyclopedia.facets.soon': 'Wkrótce',
  'encyclopedia.facets.navAria': 'Filtry typów encji',
  'encyclopedia.facets.clearAll': 'Wyczyść wszystkie filtry',
  'encyclopedia.facets.lorebook': 'Księga Lore\'u',
  'encyclopedia.facets.gameSystem': 'System Gry',
  'encyclopedia.facets.canonLayer': 'Warstwa Kanonu',
  'encyclopedia.facets.setting': 'Świat',

  // GlobalSearch
  'encyclopedia.globalSearch.title': 'Szukaj za Zasłoną',
  'encyclopedia.globalSearch.placeholder': 'Szukaj potworów, zaklęć, lokacji, lore\'u…',
  'encyclopedia.globalSearch.queryAria': 'Zapytanie wyszukiwania',
  'encyclopedia.globalSearch.loading': 'Czytanie…',
  'encyclopedia.globalSearch.empty': 'Nic się nie rusza w ciemności dla „{q}".',

  // LockedContent — LockBadge
  'encyclopedia.lockBadge.title': 'Zawartość Grymwyrd — odblokuj, aby przeczytać',
  'encyclopedia.lockBadge.label': 'Zablokowane',
  // LockedContent — LockedGate
  'encyclopedia.lockedGate.regionAria': 'Zablokowana zawartość',
  'encyclopedia.lockedGate.defaultTitle': 'Ten los jest zapieczętowany',
  'encyclopedia.lockedGate.body':
    'Własny bestiariusz Grymwyrd, zaklęcia i legendy są powiązane z Katakizmem Grymwyrd. Otwarty kanon SRD pozostaje darmowy — ale aby przejść przez wieczną zmierzch, zdobądź książkę.',
  'encyclopedia.lockedGate.unlockCta': 'Odblokuj Grymwyrd',
  'encyclopedia.lockedGate.signInCta': 'Jesteś już wspierającym? Zaloguj się',
  'encyclopedia.lockedGate.backerNote':
    'Wspierający, którzy złożyli wkład na Grymwyrd, już to posiadają — zaloguj się, aby odblokować to na swoim koncie.',

  // TableView
  'encyclopedia.table.rollToastTitle': '{name} — wyrzucone {total}',
  'encyclopedia.table.noRowMatched': 'Żaden wiersz nie pasuje do {total}.',
  'encyclopedia.table.loading': 'Rozwijanie tabeli…',
  'encyclopedia.table.error': 'Ta tabela nie mogła być narysowana.',
  'encyclopedia.table.roll': 'Rzuć {formula}',
  'encyclopedia.table.lastRoll': 'Ostatni rzut: {value}',
  'encyclopedia.table.noMatchingRow': ' · brak pasującego wiersza',

  // EntityDetailPage
  'encyclopedia.detail.entryFallback': 'Wpis',
  'encyclopedia.detail.addedToCampaign': 'Dodano do twojej kampanii.',
  'encyclopedia.detail.addError': 'Nie udało się dotrzeć do skarbca kampanii. Spróbuj później.',
  'encyclopedia.detail.unknownType': 'Nieznany typ wpisu.',
  'encyclopedia.detail.seoDescription': '{name} — {label} w Encyklopedii Grymwyrd.',
  'encyclopedia.detail.breadcrumbAria': 'Nawigacja',
  'encyclopedia.detail.breadcrumbRoot': 'Encyklopedia',
  'encyclopedia.detail.sourceVersionAria': 'Wersja źródła',
  'encyclopedia.detail.versionConsolidated': 'Skonsolidowana',
  'encyclopedia.detail.versionBook': 'Konkretna Książka',
  'encyclopedia.detail.removeBookmarkAria': 'Usuń zakładkę',
  'encyclopedia.detail.addBookmarkAria': 'Dodaj zakładkę',
  'encyclopedia.detail.bookmarked': 'Oznakowana zakładką',
  'encyclopedia.detail.bookmark': 'Zakładka',
  'encyclopedia.detail.addToCampaign': 'Dodaj do Kampanii',
  'encyclopedia.detail.sealedTitle': '{name} jest zapieczętowany',
  'encyclopedia.detail.bookVariantNote':
    'Wyświetlanie skonsolidowanego rekordu; wariantowy tekst z poszczególnych książek pojawi się tutaj po powiązaniu wydań książek.',
  'encyclopedia.detail.tablistAria': 'Sekcje wpisu',
  'encyclopedia.detail.tab.lore': 'Lore',
  'encyclopedia.detail.tab.stats': 'Statystyki',
  'encyclopedia.detail.tab.gallery': 'Galeria',
  'encyclopedia.detail.tab.relations': 'Relacje',
  'encyclopedia.detail.tab.discussions': 'Dyskusje',
  'encyclopedia.detail.tab.claims': 'Roszczenia Graczy',
  'encyclopedia.detail.loading': 'Budzenie wpisu…',

  // tabs/LoreTab
  'encyclopedia.lore.loading': 'Wydobywanie lore\'u…',
  'encyclopedia.lore.empty': 'Historia tego wpisu pozostaje niepisana.',

  // tabs/StatsTab
  'encyclopedia.stats.loading': 'Czytanie run…',
  'encyclopedia.stats.empty': 'Żadne zasady nie są zarejestrowane dla tego wpisu.',

  // tabs/GalleryTab
  'encyclopedia.gallery.loading': 'Wywoływanie wizji…',
  'encyclopedia.gallery.emptyTitle': 'Brak Wizji',
  'encyclopedia.gallery.emptyBody': 'Do tego wpisu nie powiązano żadnych ilustracji. Wnieś jedną w Skarbcu.',
  'encyclopedia.gallery.artworkAlt': 'Ilustracja encji',

  // tabs/DiscussionsTab
  'encyclopedia.discussions.loading': 'Zbieranie szeptów…',
  'encyclopedia.discussions.emptyTitle': 'Cisza w Salach',
  'encyclopedia.discussions.emptyBody': 'Bądź pierwszy(-a), aby omówić ten wpis z innymi wędrownikami.',
  'encyclopedia.discussions.startCta': 'Rozpocznij Dyskusję',
  'encyclopedia.discussions.untitledThread': 'Wątek bez tytułu',
  'encyclopedia.discussions.byAuthor': 'od {author}',
  'encyclopedia.discussions.replyCount': '{count} odpowiedzi',

  // tabs/ClaimsTab
  'encyclopedia.claims.recorded': 'Twoje roszczenie zostało zarejestrowane do przeglądu.',
  'encyclopedia.claims.recordError': 'Skrybowie nie mogli zarejestrować twojego roszczenia. Spróbuj później.',
  'encyclopedia.claims.loading': 'Konsultowanie kanonu…',
  'encyclopedia.claims.emptyTitle': 'Brak Roszczeń Graczy',
  'encyclopedia.claims.emptyBody': 'Żaden wędrownicy nie wyplótł jeszcze swojej legendy w ten wpis.',
  'encyclopedia.claims.claimCta': 'Zawłaszcz to',
  'encyclopedia.claims.signInCta': 'Zaloguj się, aby zawłaszczyć roszczenie',
  'encyclopedia.claims.untitledClaim': 'Roszczenie bez tytułu',
  'encyclopedia.claims.byAuthor': 'od {author}',
  'encyclopedia.claims.addCta': 'Dodaj swoje roszczenie',

  // tabs/RelationsTab
  'encyclopedia.relations.thisEntry': 'Ten Wpis',
  'encyclopedia.relations.relationLabel': 'Relacja {index}',
  'encyclopedia.relations.kindredLabel': 'Spokrewniony {index}',
  'encyclopedia.relations.loading': 'Śledzenie nici losu…',
  'encyclopedia.relations.hintIntro': 'Kliknij węzeł, aby przejść do tego wpisu. Pokazywane są nici',
  'encyclopedia.relations.hintCanonical': ' kanonicznym relacjom.',
  'encyclopedia.relations.hintKindred': ' spokrewnionym tego samego typu.',
}
